import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isCollapse: false,
    sideWidths: 200,
  },
  mutations: {
    OnCollapse(state, num) {
      state.isCollapse = num;
    },
    OnWidths(state, num) {
      state.sideWidths = num;
    },
  },
  actions: {},
  modules: {},
});
